import GatsbyImage from "gatsby-image";
import styled from "@emotion/styled";

export default styled(GatsbyImage)`
  height: 300px;
  border-radius: 6px;
`;
